import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../services/api';

const cardStyle = {
  backgroundColor: 'rgba(255,255,255,0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: '32px',
  boxShadow: '0 25px 50px -12px rgba(59,130,246,0.5)',
  width: '100%',
  maxWidth: '440px',
  padding: '3rem',
  marginTop: '80px',
  border: '1px solid rgba(255,255,255,0.5)',
  position: 'relative',
  overflow: 'hidden',
  zIndex: 10,
};

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setEnviado(true);
    } catch {
      toast.error('Error al enviar el correo. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0f9ff 0%, #ffffff 50%, #eff6ff 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '1rem', position: 'relative', overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        backgroundColor: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(10px)',
        padding: '0.75rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderBottom: '1px solid rgba(59,130,246,0.1)', boxShadow: '0 4px 20px rgba(59,130,246,0.05)', zIndex: 1000,
      }}>
        <span style={{ fontSize: '1.5rem', fontWeight: '700', color: '#3b82f6' }}>🎯 FactuTracks</span>
        <Link to="/login" style={{
          backgroundColor: 'white', color: '#4b5563', textDecoration: 'none',
          padding: '0.625rem 1.25rem', borderRadius: '8px', border: '1px solid #e5e7eb',
          fontSize: '0.875rem', fontWeight: '500',
        }}>← Volver</Link>
      </div>

      <div style={cardStyle}>
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: '4px',
          background: 'linear-gradient(90deg, #3b82f6, #93c5fd, #3b82f6)',
          borderTopLeftRadius: '32px', borderTopRightRadius: '32px',
        }} />

        {enviado ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📧</div>
            <h2 style={{ fontSize: '1.4rem', fontWeight: '800', color: '#111827', marginBottom: '0.75rem' }}>
              Revisa tu correo
            </h2>
            <p style={{ color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '2rem' }}>
              Si el email está registrado, recibirás un enlace para restablecer tu contraseña.
              El enlace expira en <strong>1 hora</strong>.
            </p>
            <Link to="/login" style={{
              display: 'block', textAlign: 'center', padding: '0.875rem',
              backgroundColor: '#3b82f6', color: 'white', borderRadius: '16px',
              textDecoration: 'none', fontWeight: '600', fontSize: '1rem',
            }}>
              Volver al inicio de sesión
            </Link>
          </div>
        ) : (
          <>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '800', color: '#111827', textAlign: 'center', marginBottom: '0.5rem' }}>
              Recuperar contraseña
            </h2>
            <p style={{ textAlign: 'center', color: '#6b7280', fontSize: '0.875rem', marginBottom: '2rem' }}>
              Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
            </p>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151', fontSize: '0.875rem' }}>
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  placeholder="tu@email.com"
                  style={{
                    width: '100%', padding: '0.875rem 1.25rem',
                    border: '2px solid #e5e7eb', borderRadius: '16px',
                    fontSize: '0.875rem', outline: 'none',
                    backgroundColor: 'rgba(255,255,255,0.9)', boxSizing: 'border-box',
                  }}
                  onFocus={e => { e.target.style.borderColor = '#3b82f6'; e.target.style.boxShadow = '0 0 0 4px rgba(59,130,246,0.1)'; }}
                  onBlur={e => { e.target.style.borderColor = '#e5e7eb'; e.target.style.boxShadow = 'none'; }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%', padding: '0.875rem', backgroundColor: '#3b82f6',
                  color: 'white', border: 'none', borderRadius: '16px',
                  fontSize: '1rem', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1, boxShadow: '0 8px 14px -4px rgba(59,130,246,0.4)',
                  marginBottom: '1rem',
                }}
              >
                {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
              </button>
            </form>

            <div style={{ textAlign: 'center', color: '#6b7280', fontSize: '0.875rem' }}>
              <Link to="/login" style={{ color: '#3b82f6', textDecoration: 'none', fontWeight: '600' }}>
                Volver al inicio de sesión
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
